import { Layer } from '@deck.gl/core';
import TransformFactory from "./transforms/TransformFactory.js";
const DEFAULT_PADDING = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
export function fitBounds(options) {
  const {
    width,
    height,
    bounds,
    minExtent = 0,
    // 0.01 would be about 1000 meters (degree is ~110KM)
    maxZoom = 24,
    // ~x4,000,000 => About 10 meter extents
    offset = [0, 0]
  } = options;
  const [[west, south], [east, north]] = bounds;
  const padding = {
    ...DEFAULT_PADDING,
    ...options.padding
  };
  const nw = [west, north];
  const se = [east, south];

  // width/height on the Web Mercator plane
  const size = [Math.max(Math.abs(se[0] - nw[0]), minExtent), Math.max(Math.abs(se[1] - nw[1]), minExtent)];
  const targetSize = [width - padding.left - padding.right - Math.abs(offset[0]) * 2, height - padding.top - padding.bottom - Math.abs(offset[1]) * 2];

  // scale = screen pixels per unit on the Web Mercator plane
  const scaleX = targetSize[0] / size[0];
  const scaleY = targetSize[1] / size[1];

  // Find how much we need to shift the center
  const offsetX = (padding.right - padding.left) / 2 / scaleX;
  const offsetY = (padding.top - padding.bottom) / 2 / scaleY;
  const center = [(se[0] + nw[0]) / 2 + offsetX, (se[1] + nw[1]) / 2 + offsetY];
  const zoom = Math.min(maxZoom, Math.log2(Math.abs(Math.min(scaleX, scaleY))));
  return {
    longitude: center[0],
    latitude: center[1],
    zoom
  };
}
const promiseCache = new Map();
export async function loadImageFromUrl(url) {
  if (promiseCache.has(url)) {
    return promiseCache.get(url);
  }
  const p = new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      resolve(img);
    };
    img.onerror = err => {
      reject(err);
    };
    img.src = url;
  });
  promiseCache.set(url, p);
  return p;
}
export function resolveTransformsFromCreators(transformCreators) {
  if (!transformCreators || Object.keys(transformCreators).length === 0) {
    return {};
  }
  const transforms = Object.keys(transformCreators).reduce((prev, key) => {
    const transform = TransformFactory.create(transformCreators[key]);
    if (transform) {
      prev[key] = transform;
    }
    return prev;
  }, {});
  return transforms;
}
export function addLayersToCollection(layerOrLayers, layerCollection = []) {
  if (Array.isArray(layerOrLayers)) {
    layerCollection.push(...layerOrLayers.map(layer => normalizeLayer(layer)));
  } else if (layerOrLayers != null) {
    layerCollection.push(normalizeLayer(layerOrLayers));
  }
}
function normalizeLayer(layer) {
  if (layer instanceof Layer) {
    return {
      layer
    };
  }
  return layer;
}